module.exports = __webpack_public_path__ + "img/4.eda70d43.jpg";